<template>
  <v-app>
    <v-app-bar
      app
      color="white"
    >
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="DoleFund Logo"
            class="shrink mr-2"
            contain
            src="./assets/df-logo.png"
            transition="scale-transition"
            width="100"
          />
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        to="/organizations"
        text
      >
        <span class="mr-2">Organizations</span>
      </v-btn>
      <v-btn
        to="/subscribe"
        text
      >
        <span class="mr-2">Sign Up</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from './components/Footer';

import axios from 'axios'

export default {
  name: 'App',

  components: {
    Footer
  },

  mounted: () => {
    axios.get('http://api.dolefund.com')

    // Load the recaptcha script after the app is mounted.
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=6LfoV6cZAAAAAMJzxyB1nL6RWW9yiRoO6Dt4cjWC')
    document.head.appendChild(recaptchaScript)
  },
};
</script>

<style>
.container-full {
  max-width: 100%;
  padding: 0;
}

h1 {
  margin-bottom: 2rem;
}

a {
  text-decoration: none;
  transition: 0.3s ease;
  font-weight: bold;
}

.v-application a:hover {
  color: #c4ca3f;
  text-decoration: underline;
}

.v-btn--active {
  background: #c4ca3f !important;
  color: #fff !important;
}
</style>
